import Currency from "../amount/currency";
import SearchParams from "./searchparams";
import { get as getInitData } from "./initdata";
import { isEmptyObject } from "../fetcher/support/utils";
import { callback as __callback__, getValueAtPath, isPlainObject, isString, matchedString, removeFromArray, withProperties } from "../utils";
import { CHARGE_DATA } from "./chargedata";

let CURRENCIES;
let CURRENCY_OPTIONS;
let PAYMENT_OPTIONS;
let CURRENT_PAYMENT_OPTION;
let INITIAL_PAYMENT_OPTION;

const APPLE_PAY_CURRENCIES = "AED ALL AUD BGN BHD BND CAD CHF CLP CNY COP CRC CZK DKK DOP DZD EGP EUR GBP GHS GMD GTQ HKD HNL HUF IDR ILS INR IQD ISK JOD JPY KHR KRW KWD LBP LKR LYD MAD MOP MYR NGN NOK NZD OMR PAB PHP PYG QAR SAR SDD SEK SGD SLL SVC SYP THB TND TWD TZS UGX USD VND YER ZAR ZMK ZMW".split(" ")

function __canUseApplePay__() {
  try {
    return (
      "ApplePaySession" in window &&
      window.ApplePaySession.canMakePayments() === true
    )
  } catch (e) { return false }
}

function __disableOptions__(currency, ...options) {
  if (isString(currency) && isPlainObject(CURRENCY_OPTIONS)) {
    const currencies = [].concat(currency.split(/\s*\|\s*/).filter(Boolean));

    currencies.forEach(currency => {
      if (currency in CURRENCY_OPTIONS) {
        options.forEach(option => {
          CURRENCY_OPTIONS[currency] = removeFromArray(CURRENCY_OPTIONS[currency], option);
        });
      }
    });
  }
}

// Bank transfer opens first wherever it is offered, overriding merchant and
// last-used preferences. A stablecoin price is the exception: stablecoin leads.
function getPreferredPaymentOption(currency, options) {
  return Array.isArray(options) &&
    options.indexOf('stablecoin') < 0 &&
    options.indexOf('banktransfer') >= 0
    ? 'banktransfer'
    : null;
}

function __aggregateAvailablePaymentOptions__(currencyOptions) {
  CURRENCY_OPTIONS = isPlainObject(currencyOptions) ? currencyOptions : {};

  if (SearchParams.hasErrors()) {
    const $currencyOptions = Object.create(null);

    Object.keys(CURRENCY_OPTIONS).forEach(currency => {
      $currencyOptions[currency] = Object.freeze([]);
    });

    CURRENCY_OPTIONS = $currencyOptions;
  }

  const canUseApplePay = getValueAtPath(CHARGE_DATA, 'allowApplePay') === true;

  if (!(canUseApplePay || __canUseApplePay__())) {
    APPLE_PAY_CURRENCIES.forEach(currency => {
      if (currency in CURRENCY_OPTIONS) {
        __disableOptions__(currency, 'applepay');
      }
    });
  }

  // if ('NGN' in CURRENCY_OPTIONS) {
    // CURRENCY_OPTIONS['NGN'].push('internetbanking');
    // CURRENCY_OPTIONS['NGN'].push('qr');
  // }

  __disableOptions__('NGN', 'credit', 'internetbanking', 'qr', 'payattitude');
  __disableOptions__('USD | EUR | GBP', 'banktransfer');
  __disableOptions__('KES', 'wechat');
  __disableOptions__('USD', 'account')

  CURRENCIES = Object.keys(CURRENCY_OPTIONS)
    .filter(currency => (
      SearchParams.get('currency') === (currency = String(currency).toUpperCase()) ||
      Currency.DCC.indexOf(Currency) >= 0
    ));

  PAYMENT_OPTIONS = CURRENCIES.reduce(function (options, currency) {
    if (!SearchParams.hasErrors()) {
      for (const option of CURRENCY_OPTIONS[currency]) {
        if (options.indexOf(option) < 0) {
          options.push(option);
        }
      }
    }

    return options;
  }, []);
}

function __initializePaymentOptions__($initData) {
  if (isPlainObject($initData) && !isEmptyObject($initData)) {
    let option = $initData.get('initial.payment_option');
    let country = matchedString(/^[a-z]{2}$/i, SearchParams.get('country')) || 'NG';
    let currency = matchedString(/^[a-z]{3}$/i, $initData.get('initial.currency'));

    country = country && country.toUpperCase();
    currency = currency && currency.toUpperCase();

    __aggregateAvailablePaymentOptions__.call(this, $initData.get('payment_options'));

    currency = CURRENCIES.indexOf(currency) >= 0 ? currency : null;
    option = currency && (PAYMENT_OPTIONS.indexOf(option) >= 0 ? option : null);

    if (!INITIAL_PAYMENT_OPTION) {
      INITIAL_PAYMENT_OPTION = Object.create(null);
    }

    withProperties(INITIAL_PAYMENT_OPTION, CURRENT_PAYMENT_OPTION = { country, currency, option });

    Object.freeze(CURRENCIES);
    Object.freeze(CURRENCY_OPTIONS);
    Object.freeze(PAYMENT_OPTIONS);
    Object.freeze(INITIAL_PAYMENT_OPTION);
  }
}

function __ready__(callback) {
  return (
    CURRENCY_OPTIONS
      ? Promise.resolve()
      : getInitData().then(__initializePaymentOptions__)
  ).then(__callback__(callback));
}

function getCurrencies() {
  return __ready__(() => CURRENCIES);
}

function getCurrentPaymentOption() {
  return __ready__(() => CURRENT_PAYMENT_OPTION);
}

function getInitialPaymentOption() {
  return __ready__(() => INITIAL_PAYMENT_OPTION);
}

function getPaymentOptions(currency) {
  return __ready__(() => {
    if (currency === undefined) {
      return PAYMENT_OPTIONS;
    }

    currency = String(Currency.from(currency));

    return CURRENCIES.indexOf(currency) >= 0
      ? CURRENCY_OPTIONS[currency]
      : [];
  });
}

export {
  CURRENCIES,
  PAYMENT_OPTIONS,
  CURRENCY_OPTIONS,
  INITIAL_PAYMENT_OPTION,
  getCurrencies,
  getCurrentPaymentOption,
  getInitialPaymentOption,
  getPaymentOptions,
  getPreferredPaymentOption,
  __initializePaymentOptions__ as initializePaymentOptions
};

export default getPaymentOptions;
